import { createBrowserRouter } from 'react-router';
import RootLayout from '@/layouts/RootLayout';
import AuthRootLayout from '@/layouts/AuthRootLayout';
import { WithAuth } from '@/utils/HOCs';

const noop = () => null;

const router = createBrowserRouter([
  {
    Component: WithAuth(RootLayout),
    children: [
      {
        index: true,
        HydrateFallback: noop,
        async lazy() {
          const { default: Home } = await import('./Home');
          return { Component: Home };
        },
      },
      {
        path: '/me',
        HydrateFallback: noop,
        async lazy() {
          const { default: UserProfile } = await import('./UserProfile');
          return { Component: UserProfile };
        },
      },
      {
        path: '/demo',
        HydrateFallback: noop,
        async lazy() {
          const { default: ComponentsDemo } = await import('./ComponentsDemo');
          return { Component: ComponentsDemo };
        },
      },
      {
        path: '/add-game',
        HydrateFallback: noop,
        async lazy() {
          const { default: AddGame } = await import('./AddGame');
          return { Component: AddGame };
        },
      },
      {
        path: '/teams',
        HydrateFallback: noop,
        async lazy() {
          const { default: Teams } = await import('./Teams');
          return { Component: Teams };
        },
      },
    ],
  },
  {
    Component: AuthRootLayout,
    path: '/auth',
    children: [
      {
        path: 'login',
        HydrateFallback: noop,
        async lazy() {
          const { default: Login } = await import('./Login');
          return { Component: Login };
        },
      },
      {
        path: 'forgot-password',
        HydrateFallback: noop,
        async lazy() {
          const { default: ForgotPassword } = await import('./ForgotPassword');
          return { Component: ForgotPassword };
        },
      },
      {
        path: 'reset-password',
        HydrateFallback: noop,
        async lazy() {
          const { default: ResetPassword } = await import('./ResetPassword');
          return { Component: ResetPassword };
        },
      },
    ],
  },
]);

export default router;
